import React from 'react';
// import PropTypes from 'prop-types';
import { Form } from 'react-bootstrap';
import { useForm, Controller } from 'react-hook-form';
import styles from './FacilityUnitsPriceEditor.scss';
import switchStyles from '../../../../../src/web/components/form/inputs/Switch/Switch.scss';

const OpaqueText = ({ text }) => (
  <p className={styles.opaquetext}>{text}</p>
);

const renderControlLabel = label => (
    <Form.Label>
      <span className={styles.headerStyle}>{label}</span>
    </Form.Label>
);

const FacilityUnitsPriceEditor = ({ priceDisplay = {}, onPriceDisplayChange, tableTheme }) => {
  const { control } = useForm({
    defaultValues: {
      displayCents: priceDisplay?.displayCents ?? false,
      showCents: priceDisplay?.showCents ?? true,
      showPricingLabel: priceDisplay?.showPricingLabel ?? false,
    },
  });

  return (

    <div className="units-table-editor">
      <div className="price-display-tab">
      <div className={styles.header} />

        <div className="toggle-button-group">
        <Controller
          name="displayCents"
          control={control}
          render={({ field: { name, onBlur } }) => (
              <Form.Group>
                <div className={styles.switch}>
                  <label className={switchStyles.switch}>
                    <input
                      type="checkbox"
                      name={name}
                      checked={priceDisplay?.displayCents}
                      onChange={(e) => {
                        onPriceDisplayChange({ type: 'priceDisplay', key: 'displayCents', value: e.target.checked });
                        onPriceDisplayChange({ type: 'priceDisplay', key: 'showCents', value: e.target.checked });
                      }}
                      onBlur={onBlur}
                    />
                    <span className={switchStyles.slider} />
                  </label>
                  {renderControlLabel('Display Cents')}
                </div>
                <OpaqueText text="Example: $49.99. When disabled prices will be rounded to the nearest dollar" />
              </Form.Group>
          )}
        />


        </div>

        {priceDisplay?.displayCents && (
          <div className="toggle-button-group">
            <Controller
              name="showCents"
              control={control}
              render={({ field: { name, onBlur } }) => (
                <Form.Group>
                  <div className={styles.switch}>
                    <label className={switchStyles.switch}>
                      <input
                        type="checkbox"
                        name={name}
                        checked={priceDisplay ? priceDisplay.showCents : true}
                        onChange={(e) => {
                          onPriceDisplayChange({ type: 'priceDisplay', key: 'showCents', value: e.target.checked });
                        }}
                        onBlur={onBlur}
                      />
                      <span className={switchStyles.slider} />
                    </label>
                    {renderControlLabel('Display $.00')}
                  </div>
                  <OpaqueText text="Example: Disabled $49; Enabled $49.00" />
                </Form.Group>
              )}
            />
          </div>
        )}

        {tableTheme === 'one' && (
          <div className="toggle-button-group">
            <Controller
              name="showPricingLabel"
              control={control}
              render={({ field: { name, onBlur } }) => (
                <Form.Group>
                  <div className={styles.switch}>
                    <label className={switchStyles.switch}>
                      <input
                        type="checkbox"
                        name={name}
                        checked={priceDisplay ? priceDisplay.showPricingLabel : true}
                        onChange={(e) => {
                          onPriceDisplayChange({ type: 'priceDisplay', key: 'showPricingLabel', value: e.target.checked });
                        }}
                        onBlur={onBlur}
                      />
                      <span className={switchStyles.slider} />
                    </label>
                    {renderControlLabel('Display Pricing Label - Web Rate / In Store')}
                  </div>
                  <OpaqueText text="Example: Web Rate $89; In Store $99" />
                </Form.Group>
              )}
            />
          </div>
        )}

        <div className={styles.footer} />
      </div>
    </div>
  );
};

export default FacilityUnitsPriceEditor;
